const object = (v) => !!v && typeof v === 'object' && !Array.isArray(v);
const text = (v) => typeof v === 'string' && v.length <= 500;
const finite = (v) => typeof v === 'number' && Number.isFinite(v) && Math.abs(v) <= 1_000_000;
function props(value) {
    if (!object(value))
        return;
    const result = {};
    for (const [group, fields] of Object.entries({ geometry: ['x', 'y', 'width', 'height'], spacing: ['padding', 'itemSpacing'],
        typography: ['fontSize', 'fontWeight', 'fontFamily', 'lineHeight', 'letterSpacing'], color: ['fill', 'background'] })) {
        if (value[group] === undefined)
            continue;
        if (!object(value[group]))
            return;
        const selected = {};
        for (const field of fields) {
            const v = value[group][field];
            if (v === undefined)
                continue;
            if (field === 'padding' ? !Array.isArray(v) || v.length !== 4 || !v.every(finite)
                : ['fontFamily', 'fill', 'background'].includes(field) ? !text(v) : !finite(v))
                return;
            selected[field] = v;
        }
        result[group] = selected;
    }
    return result;
}
/** Optional measured evidence has the same fail-soft contract as captured CSS. */
export function readMeasuredComparison(value) {
    if (!object(value) || !['figma', 'image'].includes(value.sourceKind))
        return;
    const reference = props(value.reference), live = props(value.live);
    if (!reference || !live || !Array.isArray(value.deltas) || value.deltas.length > 50)
        return;
    if (!value.deltas.every((d) => object(d) && ['property', 'expected', 'actual', 'delta'].every(k => text(d[k]))
        && typeof d.withinTolerance === 'boolean'))
        return;
    return { sourceKind: value.sourceKind, reference, live, deltas: value.deltas.map(({ property, expected, actual, delta, withinTolerance }) => ({ property, expected, actual, delta, withinTolerance })) };
}
/** The first family of a declared font stack, unquoted. Issue text names one
 * font; the Element card keeps the whole stack from the deltas. */
export function firstFontFamily(value) {
    return value.split(',')[0].trim().replace(/^["']|["']$/g, '');
}
export function measuredComparisonText(value) {
    const measured = readMeasuredComparison(value);
    if (!measured?.deltas.length)
        return;
    const show = (property, v) => (property === 'fontFamily' ? firstFontFamily(v) : v);
    return 'Measured values:\n' + measured.deltas.map(d => `${d.property}: Design ${show(d.property, d.expected)}; Live ${show(d.property, d.actual)}${d.delta ? `; Difference ${d.delta}` : ''}.`).join('\n');
}
//# sourceMappingURL=measuredComparison.js.map